export const isMediumOrLargeScreen = window.innerWidth >= 712;
export const peopleCount = ["<20", "20-39", "40-59", "60-79", "80-89", "100+"];
export const mealTimings = {
  breakfast: ["8:00 AM", "9:00 AM", "10:00 AM"],
  lunch: ["11:30 AM", "12:00 PM", "12:30 PM"],
  dinner: ["4:00 PM", "5:00 PM", "6:00 PM"],
};
export const defaultMealTimePickerValue = [
  { breakfast: "8:00 PM", predefinedTime: true },
  { lunch: "10:00 PM", predefinedTime: true },
  { dinner: "9:00 PM", predefinedTime: true },
];
export const weekDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const canadianProvinces = [
  "Alberta",
  "Manitoba",
  "New Brunswick",
  "Nova Scotia",
  "British Columbia",
  "Ontario",
  "Newfoundland and Labrador",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon",
  "Nunavut",
  "Northwest Territories",
];
export const TestimonialText = [
  {
    text: (
      <p>
        <span className="font-inter-medium">
          The customer service at hungerhub is phenomenal.
        </span>{" "}
        <br />
        They have always been{" "}
        <span className="font-inter-medium">
          very quick to respond and
        </span>{" "}
        <br /> very{" "}
        <span className="font-inter-semibold">
          willing to make things right
        </span>
        . Especially Nick,
        <br /> who is absolutely fantastic to deal with and always
        <br /> follows up!
      </p>
    ),
    username: "Tom Doe",
  },
];
